<template>
  <v-card elevation="0">
    <p
      v-if="!listResoluciones.length"
      class=" font-weight-bold text-15" style="color:#1D2E4B">
        Para adjuntar el proyecto de resolución, haga click en el botón
        <span class="mx-3">
          <v-btn
            v-if="(currentUser.id === item_cuenta.relator_id ||
              currentUser.id === item_cuenta.magistrado_id) &&
              item_cuenta.status != 45"
            small
            color="#3F5062"
            dark
            @click="dialogUploadFile = true"
          >Adjuntar proyecto de resolución</v-btn>
        </span>

    </p>
    <div class="mt-n3 ml-3 mr-3" v-if="listResoluciones.length">
      <div>
        <v-simple-table >
          <template v-slot:default color="#dce9f7">
            <thead>
            <tr>
              <th class="text-center font-weight-bold pl-0 body-2">
                NOMBRE
              </th>
              <th class="text-center font-weight-bold pl-0 body-2">
                TAMAÑO
              </th>
              <th class="text-center font-weight-bold pl-0 body-2">
                FECHA
              </th>
              <th class="text-center font-weight-bold pl-0 body-2">
              </th>
              <th class="text-center font-weight-bold pl-0 body-2">
                ACCIONES
              </th>
            </tr>
            </thead>

            <!-- tr Evidencia resolución -->
            <tbody>
              <tr justify="center" v-for="(doc, i) in listResoluciones" :key="'doc_'+ i">
                <td class="text-center  body-1 pl-0">
                  <span v-if="doc.url">
                    {{ doc.nombre }}
                  </span>
                  <span v-if="doc.url_original">
                    {{ doc.nombre_original }}
                  </span>
                </td>
                <td class=" text-center body-1 pl-0">
                  <span v-if="doc.url">
                    {{ doc.size | megas }} MB
                  </span>
                  <span v-if="doc.url_original">
                    {{ doc.size_original | megas }} MB
                  </span>
                </td>
                <td class=" text-center body-1 pl-0">
                  {{  doc.created_at | formatDate }}
                </td>
                <td class=" text-center body-1 pl-0">
                  <!-- <span v-if="((item_cuenta.resolucion_proyecto.some( documento => documento.valid_user_id != null ) && roleUser == 'magistrado' )) && (!resolucion_evidencia.length)"> -->
                  <!-- <span v-if="!doc.valid_user_id && roleUser == 'magistrado'"> -->
                  <span v-if="!doc.valid_user_id && doc.url">
                    <v-icon color="warning" >
                      mdi-alert-circle-outline
                    </v-icon>
                    <b>&nbsp;Pendiente de Validar</b>
                  </span>
                  <!-- <span v-if="doc.valid_user_id != null && roleUser == 'magistrado'"> -->
                  <span v-if="doc.valid_user_id != null && !doc.url_original">
                    <v-icon color="green" >
                      mdi-check
                    </v-icon>
                    <b>&nbsp;Proyecto de Resolución Validado</b>
                  </span>
                  <span v-if="!doc.url_evidencia && doc.url_original">
                    <v-icon color="cyan darken-1" >
                      mdi-file-document-edit-outline
                    </v-icon>
                    <span><b>&nbsp;En proceso de firmas</b></span>
                  </span>
                  <span v-if="doc.url_evidencia && doc.url_original">
                    <v-icon color="pink" >
                      mdi-file-document-check-outline
                    </v-icon>
                    <span><b>&nbsp;Evidencia Generada</b></span>
                  </span>
                </td>
                <td class=" text-left body-1 pl-0">
                  <v-btn
                    v-if="doc.url"
                    color="#607D8B"
                    class=" white--text mx-1"
                    :loading="i == indexLoader"
                    @click="getResolucion(doc, 'proyecto', indexLoader = i)" x-small>
                    Ver proyecto de resolución&nbsp; <v-icon x-small>mdi-folder</v-icon>
                  </v-btn>
                  <v-btn v-if="currentUser.id == item_cuenta.magistrado_id && !doc.valid_user_id && doc.url"
                    color="#607D8B"
                    class=" white--text mx-1"
                    :loading="i == validLoader"
                    @click="validaResolucion(doc, validLoader = i)" x-small>
                    Validar Resolución&nbsp;
                    <v-icon dark x-small>
                      mdi-check
                    </v-icon>
                  </v-btn>
                  <v-btn
                    v-if="doc.valid_user_id != null && roleUser == 'relator' && item_cuenta.status >= 42"
                    color="#607D8B"
                    class=" white--text mx-1"
                    :loading="loadingFirmar"
                    @click="editItem(item_cuenta.apelacion, doc)" x-small>
                    Enviar a Firmas&nbsp;
                    <v-icon dark x-small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <v-btn v-if="doc.url &&
                              ( roleUser == 'relator' && !doc.valid_user_id ||
                                roleUser == 'magistrado' ) &&
                              (currentUser.id === item_cuenta.relator_id ||
                              currentUser.id === item_cuenta.magistrado_id)"
                  color="red  lighten-1" class=" white--text mx-1" @click="eliminar(doc, 'doc_proyecto')" x-small>
                    Eliminar <v-icon x-small>mdi-close</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-divider></v-divider>
      </div>
    </div>

    <v-dialog
        v-model="progress"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="blue-grey darken-2"
          dark
        >
          <v-card-text>
            Cargando Resolución
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    <v-dialog
      v-model="dialogUploadFile"
      max-width="600px"
      persistent
    >
      <!-- <v-row max-width="600px" justify="center"> -->
      <v-card>
        <v-toolbar
          color="#286090"
          dark
          class="text-uppercase"
        >
          <img src="@/assets/logo_nuevo.png" style="width:50px;height:51px" class="mr-4">
          <h2>Subir Proyecto de Resolución</h2>
        </v-toolbar>
        <v-container>
          <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
          <!-- <v-layout wrap> -->
            <v-row>
              <v-col cols="12">
                <v-file-input
                  class="mx-4 my-2"
                  v-model="file"
                  color="blue darken-2"
                  label="Seleccionar Proyecto de Resolución"
                  prepend-icon="mdi-paperclip"
                  outlined
                  dense
                  show-size
                  accept="application/pdf"
                  :rules="fileRules"
                  @change="fileSelected()"
                ></v-file-input>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mb-2"
                color="grey darken-1"
                text
                :loading="loading"
                @click.native="close">Cancelar
              </v-btn>
              <v-btn
                class="mb-2"
                color="#607D8B"
                text
                validate-on-blur
                @click.native="saveDocumento()"
                :disabled="!valid"
                :loading="loading"
                >
                SUBIR RESOLUCIÓN
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- DIALOG AGREGAR DOCUMENTO -->
    <v-dialog
      v-model="dialog"
      max-width="900px"
      persistent
    >
      <v-card>
        <v-toolbar
          color="#286090"
          dark
          class="text-uppercase"
        >
          <img src="@/assets/logo_nuevo.png" style="width:50px;height:51px" class="mr-4">
          <h2>Enviar a firmas Toca
            <b>
              {{ apelacion.toca.numero }}/{{ apelacion.toca.anio }}
              ({{ apelacion.tipo_juicio == 'JO' ? 'Juicio Oral' : 'Jucio Tradicional' }})
            </b>
          </h2>
        </v-toolbar>
        <v-container>
          <v-card-text>
            <v-form @submit.prevent="save" ref="formFirmas" v-model="valid" lazy-validation>

            <!-- Multifirma -->

              <v-row>
                <v-col cols="12" md="6" align="center">
                  <v-select
                    :items="listCategorias"
                    v-model="categoria_id"
                    @change="getTipoDocumento()"
                    label="Seleccione categoría de documento"
                    prepend-inner-icon="mdi-file-outline"
                    item-value="id"
                    item-text="nombre"
                    outlined
                    dense
                    :rules="[v => !!v|| 'Seleccione categoría de documento']"
                    >
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    :disabled="!categoria_id"
                    :items="listTipo"
                    return-object
                    v-model="tipo_documento"
                    label="Seleccione tipo de documento"
                    prepend-icon="mdi-file-outline"
                    item-value="id"
                    item-text="nombre"
                    clearable
                    outlined
                    dense
                    :rules="[v => !!v|| 'Seleccione el tipo de documento']"
                    >
                  </v-select>
                </v-col>
              </v-row>

              <v-row v-if="categoria_id && tipo_documento.nombre == 'Otro'" class="mt-n7">
                <v-col cols="12">
                  <v-textarea
                    v-model="leyenda"
                    outlined
                    label="Leyenda"
                    prepend-inner-icon="mdi-file-document-outline"
                    rows="1"
                    row-height="10"
                    counter="100"
                    maxlength="100"
                    hint="Máximo 100 caracteres"
                    :rules=" [v => !!v || 'Campo requerido']"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-row class="mt-n7">
                <v-col cols="12">
                  <v-textarea
                    v-model="extracto"
                    outlined
                    label="Extracto"
                    prepend-inner-icon="mdi-file-document-outline"
                    rows="3"
                    row-height="20"
                    counter="200"
                    maxlength="200"
                    hint="Máximo 200 caracteres"
                    :rules=" [v => v.length <= 200 || 'Requiere 200 caracteres']"
                  ></v-textarea>
                </v-col>
              </v-row>

              <!--CREAR MULTIFIRMA -->
              <v-container fluid class="mt-n5">
                <h2 style="color: #B08836" class="font-weight-bold"> Seleccione a los firmantes del documento</h2><br>
                <v-row>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    v-model="magistrado"
                    :items="listMagistrados"
                    outlined
                    dense
                    @change="addMagistrado()"
                    item-text="nombre"
                    item-value="id"
                    return-object
                    label="Seleccione Firmante"
                    prepend-icon="mdi-account"
                    persistent-hint
                    no-data-text="No se encontraron usuarios"
                    required
                  >
                  <template slot="selection" slot-scope="data">
                    <div v-if="data.item.segundo_apellido"class="select-text">
                      {{ data.item.nombre +' '+data.item.primer_apellido +' '+data.item.segundo_apellido}}
                    </div>
                    <div v-else class="select-text">
                      {{ data.item.nombre +' '+data.item.primer_apellido}}
                    </div>
                  </template>
                  <template slot="item" slot-scope="data">
                    <div v-if="data.item.segundo_apellido"class="select-text">
                      {{ data.item.nombre +' '+data.item.primer_apellido +' '+data.item.segundo_apellido}}
                    </div>
                    <div v-else class="select-text">
                      {{ data.item.nombre +' '+data.item.primer_apellido}}
                    </div>
                  </template>
                  </v-autocomplete>
                </v-col>
                </v-row>
              </v-container>

              <v-container v-if="magistrados.length > 0">
              <v-card class="mt-n3" elevation="0">
                <v-card-title style="color: #B08836"  class="font-weight-bold">
                  <h4 class="heading font-weight-bold"> Firmantes del documento</h4>
                </v-card-title>
                <v-row class="mt-n3">
                  <v-col cols="12" md="10">
                    <ul>
                      <li
                        v-for="(magistrado,index) in magistrados"
                        v-bind:key="magistrado.nombre"
                        v-on:remove="magistrados.splice(index, 1)"
                      >
                        <h2 v-if="magistrado.segundo_apellido">
                          {{magistrado.nombre+' '+magistrado.primer_apellido+' '+magistrado.segundo_apellido}}
                          <v-btn x-small color="red darken-3" dark @click="removeMagistrado(index)">X</v-btn>
                        </h2>
                        <h2 v-else>
                          {{magistrado.nombre+' '+magistrado.primer_apellido}}
                          <v-btn x-small color="red darken-3" dark @click="removeMagistrado(index)">X</v-btn>
                        </h2>
                        <b v-if="magistrado.firmado == 1" style="color: green">Ya ha Firmado</b><br>
                      </li>
                    </ul>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
            <!--FIN MULTIFIRMA -->
            <!-- <br> -->
                <v-divider></v-divider>
                <v-card-actions class="mb-3">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="mb-2"
                    color="grey darken-1"
                    text
                    :loading="loading"
                    @click.native="closeMultifirma">Cancelar
                  </v-btn>
                  <v-btn
                    class="mb-2"
                    color="#1D2E4B"
                    text
                    :loading="loading"
                    :disabled="!valid"
                    @click="validate()"
                  >
                    Guardar Documento
                  </v-btn>
                </v-card-actions>
            </v-form>
          </v-card-text>
        </v-container>
      </v-card>
    <!-- </v-row> -->
    </v-dialog>
    <!-- FIN DIALOG AGREGAR DOCUMENTO -->
    <!-- </v-card> -->
  </v-card>
</template>

<script>
  import {mapGetters, mapMutations} from "vuex";
  // import { VueEditor } from 'vue2-editor';
  // import BaseSelect from "@/components/BaseSelect.vue";

const Swal = require('sweetalert2');

export default {
  props: {
    apelacion: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
    },
  data () {
    return {
      valid: true,
      dialog: false,
      loading:false,
      progress: false,
      showpass: false,
      loadingEliminar: false,
      // loadingValidar: false,
      loadingFirmar: false,
      indexLoader: -1,
      validLoader: -1,
      editedIndex: -1,
      loadingResolucion: false,
      dialogUploadFile:false,
      categoria_id: '',
      tipo_documento: '',
      listTipo:[],
      leyenda:'',
      extracto:'',
      magistrado:'',
      magistrados: [],
      magistrados_ids: [],
      file:[],
      files:[],
      resolucion_proyecto: '',
      resolucion_proyecto_id: '',
      resolucion_evidencia:[],
      listResoluciones:[],
      archivo:{
        encode:'',
        type: 'application/pdf',
        file_name:'',
        size:''
      },
      archivoDefault:{
        encode:'',
        type:'application/pdf',
        file_name:'',
        size:''
      },
      defaultItem: {
        file:'',
      },
      data: {
        file:'',
      },
      defaultData: {
        file:'',
      },
      message: '',
      fileRules: [
        value => !value || value.size < 20000000 || 'Selecciona un Archivo de máximo 20 MB!',
        value => !!value || 'El Campo es Requerido',
      ],
      notBlankRules: [v => !!v || 'Este campo es requerido']
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.findResoluciones()
      this.getMagistrados()
      this.getCategorias()
      this.categoria_id = 3
      this.getTipoDocumento()
  });
  },
  computed: {
    ...mapGetters(["currentUser", "listMagistrados", "listCategorias", "roleUser"]),
    formTitle () {
      return 'Proyecto de Resolución'
    },
    item_cuenta() {
      return this.item
    }

  },
  filters: {
  megas: function (value) {
    if (!value) return ''
    value = value / 1048576
    return value.toFixed(2);
    },
  },
  watch: {
    // dialog (val) {
    //   val || this.close()
    // }
    categoria_id: function (val) {
      if(val){
        this.tipo_documento = ''
        this.leyenda = ''
      }
    },
    tipo_documento: function (val) {
      if(val){
        this.leyenda = ''
      }
    }
  },
  methods: {
    findResoluciones(){
      this.listResoluciones = []
      this.listResoluciones = this.item_cuenta.resolucion_proyecto
      // var listDocumentos = this.item_cuenta.apelacion.documentos
      // listDocumentos.forEach(resolucion => {
      //     if(resolucion.categoria_id == 3){
      //       this.listResoluciones.push(resolucion)
      //     }
      //   });
    },

    getMagistrados(){
      this.$store.dispatch("GET_MAGISTRADOS",  { url: "/magistrados" })
        .then(response => {
          // console.log(response.data);
      })
      .catch(error => {
        console.log(error);
      });
    },
    getCategorias(){
      this.$store.dispatch("GET_CATEGORIAS",  { url: "/categorias" })
        .then(response => {
          // console.log(this.listCategorias);
      })
      .catch(error => {
        console.log(error);
      });
    },
    getTipoDocumento(){
      this.$store.dispatch("GET_TIPO_DOCUMENTO",  { url: "/tipos-documentos",
      params:
      {
        categoria_id:this.categoria_id
      }
      }).then(response => {
        this.listTipo = response.data.data.tipos_documentos
        // console.log(response);
      }).catch(error => {
        console.log(error);
      });
    },

    getResolucionProyecto(){
      this.$store.dispatch("GET_FILE", {
        url:"/cuenta/"+ this.resolucion_proyecto_id +"/file",
      } )
      .then((response) => {
        // console.log(response.data);
        this.bufferFile = response.data
        this.archivo['encode'] = this.arrayBufferToBase64(this.bufferFile)
        this.archivo['file_name'] = this.resolucion_proyecto.nombre
        this.archivo['size'] = this.resolucion_proyecto.size
      })
      .catch(err => {
        console.log(err);
      });
    },
    arrayBufferToBase64( buffer ) {
      var binary = '';
      var bytes = new Uint8Array( buffer );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode( bytes[ i ] );
      }
      return window.btoa( binary );
    },

    getResolucion(resolucion, tipo) {
      this.progress = true
      // this.loadingResolucion = true
      if (tipo == 'proyecto'){
        this.url = '/cuenta/'+ resolucion.id + '/file'
      }
      if (tipo == 'evidencia') {
        this.url = '/documento/'+ resolucion.id + '/multifirma-evidencia'
      }
      if (tipo == 'original') {
        this.url = '/documento/'+ resolucion.id + '/previo-multifirma'
      }
      //para .doc
      //this.$store.dispatch("GET_FILE_DOC",  { url: "/cuenta/"+ resolucion.id+"/file" } )
      this.$store.dispatch("GET_FILE",  { url: this.url } )
      .then(response => {
        //para .doc
       // const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }));
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('target' ,'_blank');
          document.body.appendChild(link);
          link.click();
          this.progress = false
          // this.loadingResolucion = false
          this.indexLoader = -1
      })
      .catch(error => {
        console.log(error);
      });
    },

    saveDocumento() {
      if(this.file == ""){
        Swal.fire({
          icon: 'warning',
          title: 'Es Obligatorio Ingresar el Documento',
          showConfirmButton: false,
          timer: 2000
        })
      } else {
        if (this.$refs.form.validate()) {
          this.FilesToUpload();
          this.loading = true
          this.progress = true
          this.data.file = this.archivo
          var data = this.data
           //console.log(data);
            this.$store.dispatch("SAVE_OFICIO",  { url: "/cuenta/" + this.item_cuenta.id + "/resolucion-proyecto", data: data } )
            .then(response => {
              //console.log(response.data);
              this.loading = false
              this.listResoluciones.push(response.data.data.proyecto)
              this.resolucion_proyecto = null
              this.showCuenta()
              this.$emit('updateCuenta', this.listResoluciones)
              this.file = []
              this.files = []
              this.progress = false
              this.close()
              this.$swal({
                icon: 'success',
                title: 'Archivo Guardado Correctamente',
                confirmButtonText: "Aceptar"
              })
            })
            .catch(error => {
              console.log(error);
            });
        }
      }
    },

    fileSelected(){
      this.files = []
      var file = this.file;
      this.getBase64(file).then(data => {
        this.files.push(data);
        //console.log('this.files',this.files);
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        }
      });
    },
    FilesToUpload() {
      if (this.files.length) {
        this.files.forEach(file => {
          var block = file.split(";");
          // Get the content type of the image
          var contentType = block[0].split(":")[1]; // In this case "jpg
          // get the real base64 content of the file
          this.archivo['type'] = contentType
          var realData = block[1].split(",")[1];
          //console.log(realData);
          this.archivo['encode'] = realData
          //para .doc
         // this.archivo['file_name'] = this.file.name.split(".doc")[0];
         this.archivo['file_name'] = this.file.name.split(".pdf")[0];
          this.archivo['size'] = this.file.size
         //console.log(this.archivo);
        });
      }
    },

    close () {
      this.dialogUploadFile = false
        this.resetValidation()
        // this.$refs.form.reset()
        // this.editedItem = Object.assign({}, this.defaultItem)
        this.data = Object.assign({}, this.defaultData)
        this.archivo = Object.assign({}, this.archivoDefault)
        this.files = []
        this.file = []
        this.file.value = null
        // this.$emit('close', false);
    },
    closeMultifirma () {
      this.dialog = false
      this.$refs.formFirmas.reset()
      this.$refs.formFirmas.resetValidation()
        // this.$refs.form.reset()
        // this.editedItem = Object.assign({}, this.defaultItem)
      this.archivo = Object.assign({}, this.archivoDefault)
      this.categoria_id = ''
      this.resolucion_proyecto_id = ''
      this.leyenda = ''
      this.extracto = ''
      this.magistrado = ''
      this.magistrados = []
      this.magistrados_ids = []
      this.editedIndex = -1
      this.dialog = false
    },

    resetValidation () {
      this.$refs.form.resetValidation()
    },

    showCuenta() {
      this.$store.dispatch("SHOW_CUENTA", {
        url: '/cuenta/'+ this.item_cuenta.id,
      })
      .then(response => {
        this.cuenta =  JSON.parse(localStorage.getItem("currentCuenta"))
      });
    },
    eliminar(doc, tipo_doc){
      Swal.fire({
        title: '¿Confirma eliminar el Proyecto de Resolución?',
        text: "Esta acción no se puede deshacer",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      }).then((result) => {
      if (result.isConfirmed) {
        var url = "/cuenta/resolucion-proyecto/" + doc.id
        if (tipo_doc == 'doc_multifirma') {
          url = "/multifirma/"+doc.id
        }
        this.loadingEliminar = true
        this.$store.dispatch("DELETE_DOCUMENTO",{
          url: url
        }).then((response) => {
          //console.log(response.data);
          this.loadingEliminar = false
          if (response.data.status=='ok') {
            Swal.fire({
              icon: 'success',
              title: 'Se eliminó correctamente',
              confirmButtonText: "Aceptar",
            })
          }
          var documento = response.data.data.documento
          var resolucionIdIndex = -1
          this.listResoluciones.forEach(function (resolucion, index) {
            // if(documento.categoria_id == 3 && documento.url_evidencia){
            if(resolucion.id == documento.id && tipo_doc == 'doc_proyecto'){
              resolucionIdIndex = index
              return
            }
            if(resolucion.id == documento.id && tipo_doc == 'doc_multifirma'){
              // console.log('index multifirma',index);
              resolucionIdIndex = index
              return
            }
          });
          // console.log('resolucionIdIndex',resolucionIdIndex);
          // this.showCuenta()
          // const resolucionIdIndex = this.listResoluciones.findIndex((resolucion) => resolucion.id === doc.id && doc.url);

          if (resolucionIdIndex > -1) {
            this.listResoluciones.splice(resolucionIdIndex, 1);
          }
          this.$emit('updateCuenta', this.listResoluciones);

          //this.$router.go(this.$router.currentRoute)
          }).catch(err => {
            console.log(err);
          });
        }
      })
    },
    validaResolucion(item){
        // this.loadingValidar = true
        var resolucion = {
          valid_user_id:this.currentUser.id
        }

        this.$store.dispatch("EDIT_DOCUMENTO",  { url: "/cuenta/"+ item.id +"/validar", data: resolucion } )
          .then(response => {
              // this.loadingValidar = false
              var resolucion_proyecto = response.data.data.documento
              var listResoluciones = this.listResoluciones
              this.listResoluciones.forEach(function (resolucion, index) {
                // if(documento.categoria_id == 3 && documento.url_evidencia){
                if(resolucion.id == resolucion_proyecto.id && resolucion.url){
                  listResoluciones[index] = resolucion_proyecto
                }
              });
              // this.showCuenta()
              this.$emit('updateCuenta', listResoluciones)
              this.validLoader = false
              this.$swal({
                icon: 'success',
                title: 'Se Validó Correctamente',
                confirmButtonText: "Aceptar"
              })
            })
            .catch(error => {
              console.log(error);
           });
      },
      validate() {
        // console.log(this.file);
        if (this.$refs.formFirmas.validate()) {
          if(this.magistrados_ids.length == 0){
            Swal.fire({
              icon: 'warning',
              title: 'Favor de Agregar Firmantes',
              confirmButtonText: "Aceptar",
            })
          }
          else {
            this.loading = true
            this.url_multifirma = "/documento/"+ this.apelacion.id +"/multifirma"
            this.saveMultifirma()
          }
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'Favor de verificar los campos Requeridos',
            confirmButtonText: "Aceptar",
          })
        }
      },
      saveMultifirma() {
        const data = {
          magistrados: this.magistrados_ids,
          file: this.archivo,
          categoria_id: this.categoria_id,
          tipo_documento_id: this.tipo_documento.id,
          resolucion_proyecto_id: this.resolucion_proyecto_id,
          leyenda: this.leyenda,
          extracto: this.extracto
          // apelacion_id: this.currentApelacion.id
        }
        this.$store.dispatch("CREATE_MULTIFIRMA",  { url: this.url_multifirma, data: data })
        // this.$store.dispatch("CREATE_MULTIFIRMA",  { url: "/previo-admision/"+ 4, data: data })
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Documento y Firmantes Registrados con Éxito',
            text: 'Para visualizar archivo ir a la sección de Documentos',
            confirmButtonText: "Aceptar",
          })
          var resolucion_proyecto_id = this.resolucion_proyecto_id
          var resolucionIdIndex = -1
          this.listResoluciones.forEach(function (resolucion, index) {
            if(resolucion.id == resolucion_proyecto_id){
              resolucionIdIndex = index
              return
            }
          });
          if (resolucionIdIndex > -1) {
            this.listResoluciones.splice(resolucionIdIndex, 1);
          }
          this.loading = false
          this.closeMultifirma();
          this.$emit('updateCuenta', this.listResoluciones)
          // if (this.roleUser == 'relator') {
          //   this.$router.push('/tocas')
          // }
          // else {
          //   this.$router.push('/secacuerdos')
          // }
        })
          .catch(error => {
            this.loading = false
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response.data.message,
              confirmButtonText: "Aceptar"
            });
            // this.close();
          });
      },
      addMagistrado() {
        if (this.magistrado=="") {
          Swal.fire({
            icon: 'warning',
            title: 'No se ha seleccionado Magistrado',
            showConfirmButton: false,
            timer: 1500
          })
        } else if (this.magistrados_ids.includes(this.magistrado.id)) {
          Swal.fire({
            icon: 'warning',
            title: this.magistrado.nombre + ' ya ha sido agregado',
            showConfirmButton: false,
            timer: 1500
          })
          this.magistrado = ''
          // this.$refs.form.reset()
        } else {
          this.magistrados.push(this.magistrado)
          this.magistrados_ids.push(this.magistrado.id)
          this.magistrado = ''
          // this.$refs.form.reset()
        }
      },
      removeMagistrado(index) {
        this.magistrados.splice(index, 1)
        this.magistrados_ids.splice(index, 1)
      },
      editItem (apelacion, doc) {
      this.resolucion_proyecto_id = doc.id
      this.resolucion_proyecto = doc
      this.categoria_id = 3
      this.getResolucionProyecto()
      this.dialog = true
    },
      enviarFirma(apelacion, resolucion_proyecto_id) {
        localStorage.setItem("currentApelacion", JSON.stringify( apelacion.id ));
        localStorage.setItem("currentProyecto", JSON.stringify( resolucion_proyecto_id ));
        this.$router.push({name: 'DocumentoCreate'});
      },
      verFirma(doc){
        localStorage.setItem("currentDocument", JSON.stringify( doc.id ));
        localStorage.setItem("currentApelacion", JSON.stringify( this.item_cuenta.apelacion_id ));
        this.$router.push('/documento/firma')
      },
  }
}
</script>

<style>
.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset{
    background-color: rgba(255, 255, 255, 0.977);
}
.v-text-field--outlined > .v-input__control > .v-input__slot {
  background-color:whitesmoke;
}
</style>
